import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    width: "100%",
    height: "100%",
    background: "linear-gradient(90deg, #F9FAFB 0%, #F2F4F7 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "120px 120px",
    "@media (max-width: 600px)": {
      padding: "40px 40px",
    },
  },
  mainGrid: {
    width: "100%",
    height: "100%",
  },
  gridContainer: {
    maxWidth: "1140px",
  },
  rightBox: {
    padding: "16px",
    height: "100%",
  },
  leftBox: {
    width: "100%",
    height: "100%",
    borderRadius: "12px 0px 0px 12px",
    background: "#FAFCFE",
    margin: "0 auto",
  },
  container: {
    height: "100%",
    width: "100%",
    margin: "0 auto",
    background: "#FFF",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
    borderRadius: "12px",
  },
  image: {
    maxWidth: "200px",
    marginTop: "5%",
    marginLeft: "8.5%",
    height: "5vh",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    color: "#465869",
    fontSize: "24px",
    marginBottom: "0px",
  },
  text: {
    fontFamily: "Manrope",
    color: "#465869",
    fontSize: "14px",
  },
  boxContainer: {
    width: "50%",
    "@media (max-width: 1300px)": {
      width: "60%",
    },
    "@media (max-width: 1100px)": {
      width: "70%",
    },
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  emailSentBoxContainer: {
    width: "65%",
    "@media (max-width: 1300px)": {
      width: "70%",
    },
    "@media (max-width: 1100px)": {
      width: "80%",
    },
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  input: {
    color: "#063663",
    fontSize: "16px",
  },
  button: {
    backgroundColor: "#476589",
  },
  gridItemForm: {
    backgroundColor: "#063663",
    padding: "50px 80px",
    "@media (max-width: 960px)": {
      padding: "50px 25px",
    },
  },
  gridItemInfoText: {
    "@media (max-width: 960px)": {
      display: "none !important",
    },
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#EEEEEE",
    padding: "60px",
    alignItems: "center",
  },
  infoText: {
    textAlign: "center",
    fontSize: "22px",
    color: "#000000",
    lineHeight: "1.7",
  },
  clickableText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#308CDB",
    cursor: "pointer",
  },

  contentCarousel: {
    width: "fit-content",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  imageCarousel: {
    width: "100%",
    height: "70%",
  },
  imageUpdatePassword: {
    width: "75%",
  },
  imageConfirmEmail: {
    width: "80%",
  },
  message: {
    paddingTop: "30px",
    margin: "0 auto",
    height: "100px",
    width: "70%",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#308CDB",
    textAlign: "center",
    whiteSpace: "normal",
  },

  slideshow: {
    margin: "0 auto",
    overflow: "hidden",
    maxWidth: "inherit",
  },

  slideshowSlider: {
    whiteSpace: "nowrap",
    transition: "ease 1000ms",
  },

  slide: {
    display: "inline-block",
    height: "37.2vh",
    width: "100%",
    marginTop: "10%",
  },

  imageUpdatePasswordContainer: {
    height: "37.2vh",
    width: "100%",
    marginTop: "8%",
    display: "flex",
    justifyContent: "center",
  },

  imageConfirmEmailContainer: {
    height: "40.2vh",
    width: "100%",
    marginTop: "8%",
    display: "flex",
    justifyContent: "center",
  },

  slideshowDots: {
    textAlign: "center",
  },

  slideshowDot: {
    display: "inline-block",
    height: "6px",
    width: "16px",
    borderRadius: "3px",

    cursor: "pointer",
    margin: "15px 8px 0px",

    backgroundColor: "#DEDEDE",
  },
  slideshowDotActive: {
    backgroundColor: "#FFF",
    width: "48px",
    borderRadius: "3px",
  },
}));

export default styles;
